import {  useEffect } from 'react';
import { Grid } from '@mui/material';
import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import MainCard from '../MainCard';


const MixedChart = ({ isLoading, categories, percentage, totalList, automatedList, selected, selectedTitle }) => {


    const mixedChartData = {
        height: 480,
        options: {
            chart: {
                height: 350,
                type: 'line',
                id: 'line-chart',
                stacked: false,
                toolbar: {
                    show: false
                },
            },
            dataLabels: {
                enabled: false
              },
            xaxis: {
                type: 'category',
                categories: categories,
            },
            yaxis: [
                         {
                  seriesName: 'Total',
                  axisTicks: {
                    show: true,
                  },
                  axisBorder: {
                    show: false,
                    color: '#60ABD2'
                  },
                  labels: {
                    style: {
                      colors: '#60ABD2',
                    }
                  },
                  title: {
                    text: "Total (cases)",
                    style: {
                      color: '#60ABD2',
                    }
                  },
                  tooltip: {
                    enabled: true
                  }
                },
                {
                  seriesName: 'Automated',
                  opposite: false,
                  axisTicks: {
                    show: false,
                  },
                  axisBorder: {
                    show: false,
                    color: '#3d85c6'
                  },
                  labels: {
                    style: {
                      colors: '#3d85c6',
                    }
                  },
                  title: {
                    text: "Automated (cases)",
                    style: {
                      color: '#3d85c6',
                    }
                  },
                },
                {
                  seriesName: '%',
                  opposite: true,
                  axisTicks: {
                    show: true,
                  },
                  axisBorder: {
                    show: false,
                    color: '#FEB019'
                  },
                  labels: {
                    style: {
                      colors: '#FEB019',
                    },
                  },
                  title: {
                    text: "%",
                    style: {
                      color: '#FEB019',
                    }
                  }
                },
            ],
            stroke: {
                width: [1, 1, 4]
            },
            title: {
                text: selectedTitle+' Automation',
                align: 'left',
                offsetX: 110
            },
            colors: ['#60ABD2','#3d85c6','#FEB019'],
        },
        series: [{
              name: 'Total',
              type: 'column',
              data: totalList
            }, {
              name: 'Automated',
              type: 'column',
              data: automatedList
            }, {
              name: '%',
              type: 'line',
              data: percentage
        }],
    };

   
    useEffect(() => {
        const newChartData = {...mixedChartData.series,};
        if (!isLoading ) {
            ApexCharts.exec(`line-chart`, 'updateOptions', newChartData);
        }
    },[isLoading, mixedChartData.series]);

    return (
        <>
        <MainCard>
            <Grid item xs={12}>
                <Chart {...mixedChartData} />
            </Grid>
        </MainCard>
        </>
    );
};

export default MixedChart;
